






















































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { QInput } from 'quasar'
import api from 'src/assets/api/rest'
import DeadlineTimer from 'components/DeadlineTimer.vue'

@Component({
  components: { DeadlineTimer }
})
export default class AccountPasswordChange extends Vue {
  step = ''
  password = ''
  code = ''
  show: boolean = false
  beginTime: Date = new Date()
  validTime: Date = new Date()
  loading: boolean = false
  error: boolean = false

  get isPasswordValid(): boolean {
    return !!this.password
  }

  get isCodeValid(): boolean {
    return this.code.length === 6 && new Date(this.validTime) > new Date()
  }

  @Ref()
  readonly input!: QInput

  back () {
    this.code = ''
    this.step = ''
    this.password = ''
    this.show = false
    this.validTime = new Date()
  }

  async save () {
    if (this.isCodeValid) {
      this.loading = true
      try {
        await api.patch('/api/account/password-change-confirm', {
          password: this.password,
          code: this.code
        })
        this.back()
      } catch (e) {
        this.error = true
        setTimeout(() => {
          this.error = false
          this.code = ''
          this.$nextTick(() => {
            this.input.focus()
          })
        }, 500)
      }
      this.loading = false
    }
  }

  async sendNewCode () {
    if (this.isPasswordValid) {
      try {
        this.loading = true
        const response = await api.post('/api/account/password-change', {
          password: this.password,
          locale: this.$i18n.locale
        })
        const data = await response.json()
        this.beginTime = new Date()
        this.validTime = new Date(data.validTime)
        this.step = 'code'
        this.code = ''
      } catch (e) {
        this.error = true
        setTimeout(() => {
          this.error = false
        }, 500)
      }
      this.loading = false
      this.$nextTick(() => {
        this.input && this.input.focus()
      })
    }
  }
}
